import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Card, Grid, TablePagination, TextField } from '@mui/material';
import {SyncLoader} from 'react-spinners'


function Sales() {

  var currentDate = new Date();
  currentDate.setDate(1);
  var startDateOfMonth = currentDate.toISOString().split('T')[0];

  var todayDate = new Date().toISOString().split('T')[0];

    const[sales,setSales] = useState([])
    const [search,setSearch] = useState('')
    const [loading,setLoading] = useState(true)
    const [startDate,setStartDate] = useState(startDateOfMonth)
    const [endDate,setEndDate] = useState(todayDate)
    const [warakapolaTotal,setWarakapolaTotal] = useState();
    const [galigamuwaTotal,setGaligamuwaTotal] = useState();
    const [total,setTotal] = useState(0)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [totalRows, setTotalRows] = useState(0)




    useEffect(() => {
      const data = {
        from_date : startDate,
        to_date : endDate
      }

      axios.post("https://bmserver.ccsoftwares.com/Sales/setTotalSalesStorewise", data)
        .then(res => {
          if (res.data) {
            setTotal(res.data.total_net);

            const warakapola = res.data.store_sales.find(s => s.store === "Warakapola");
            const galigamuwa = res.data.store_sales.find(s => s.store === "Galigamuwa");

            setWarakapolaTotal(warakapola ? warakapola.net_total : 0);
            setGaligamuwaTotal(galigamuwa ? galigamuwa.net_total : 0);

          } else {
            setWarakapolaTotal(0);
            setGaligamuwaTotal(0);
            setTotal(0);
          }
        })
        .catch(err => {
          console.error(err);
          setWarakapolaTotal(0);
          setGaligamuwaTotal(0);
          setTotal(0);
        });
    }, [endDate, startDate])

    useEffect(() => {
      setLoading(true);
      const data = {
        page: page + 1,
        limit: rowsPerPage,
        search,
        store: 'all',
        from_date: startDate,
        to_date: endDate
      };

      axios.post("https://bmserver.ccsoftwares.com/Sales/paginated", data)
        .then(res => {
          setSales(res.data?.data || []);
          setTotalRows(res.data?.pagination?.total || 0);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setSales([]);
          setTotalRows(0);
          setLoading(false);
        });
    }, [endDate, page, rowsPerPage, search, startDate])

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'LKR', // Change to your desired currency code
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      }).format(value);
  };
    



  return (
    <>
    <div style={{backgroundColor  :'white',width : '100%',marginLeft : 10}}>
      <Grid container spacing={2}>

 
                <Grid item md={6} xs={12}>
                    <TextField
                        placeholder=''
                        type='date'
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Date from "
                        value={startDate}
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          setPage(0);
                        }}
                        >
                    </TextField>
                </Grid>
                <Grid item md={6} xs={12}>
                    <TextField
                        placeholder=''
                        type='date'
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Date To "
                        value={endDate}
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                          setPage(0);
                        }}
                        >
                    </TextField>
                </Grid>
                </Grid>

        <TextField
          id="standard-basic"
          label="Search by Invoice No / Product name"
          variant="standard"
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(0);
          }}
          fullWidth
          autoComplete="off"
        />
    </div>
    {loading ? (
      <div style={{display : 'flex',justifyContent : 'center',alignItems : 'center',height : '100vh'}}>
        <SyncLoader color="#1e1e1e" />
      </div>
    ) : (
<>
    <Grid container style={{marginTop : 20}}>
      <Grid md = {4} xs = {12}>
        <Card style={{height : '100px',justifyContent : 'center',display : 'flex',alignItems : 'center'}}>
          <div style={{display : 'flex'}}>
       
            Selected period Net Total : 
        
      
           {formatCurrency(total)}
        
          </div>
        </Card>
      </Grid>
      <Grid md = {4} xs = {12}>
      <Card style={{height : '100px',justifyContent : 'center',display : 'flex',alignItems : 'center'}}>
 Galigamuwa Net Total :  {formatCurrency(galigamuwaTotal)} 
         
        </Card>
      </Grid>
      <Grid md = {4} xs = {12}>
      <Card style={{height : '100px',justifyContent : 'center',display : 'flex',alignItems : 'center'}}>

          Warakapola Net Total : 
           {formatCurrency(warakapolaTotal)} <br></br>
        </Card>
      </Grid>

    </Grid>

    <div style={{display : 'flex',justifyContent : 'center',marginTop : 70}}>
    <TableContainer component={Paper}>
      <Table aria-label="sales table">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Invoice No</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Product Name</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Qty</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Cashier</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Gross Total</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Net Total</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Discount</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Shop</TableCell>
            <TableCell style={{fontWeight : 'bold'}}>Bill Date /Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sales.map((e, i) => (
            <TableRow key={`${e.invoice_no}-${i}`}>
              <TableCell>{page * rowsPerPage + i + 1}</TableCell>
              <TableCell>{e.invoice_no}</TableCell>
              <TableCell>{e.product_name}</TableCell>
              <TableCell>{e.qty}</TableCell>
              <TableCell>{e.cashier}</TableCell>
              <TableCell>Rs.{e.gross_total}.00</TableCell>
              <TableCell>Rs.{e.net_total}.00</TableCell>
              <TableCell>Rs.{e.discount}.00</TableCell>
              <TableCell>{e.store}</TableCell>
              <TableCell>{e.bill_date.split('T')[0]} / {e.bill_time}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50, 100]}
      />
    </TableContainer>
        </div>
        </>
    )}



    </>


  )
}

export default Sales
